import { createSlice } from '@reduxjs/toolkit';
import { GoalState } from './goalType';
import { createGoal , fetchAllGoal , UpdateGoal , deleteGoal,fetchGoalById } from './goalAction';

const initialState : GoalState = {
    goal : [],
    selectedgoal : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}


const goalSlice = createSlice({
    name : 'goal',
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
            .addCase(createGoal.pending, (state) => {
                                              state.loadingStates.create = true;
                                              state.errors.create = undefined;
                                          })
                                          .addCase(createGoal.fulfilled, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.goal.push(action.payload);
                                          })
                                          .addCase(createGoal.rejected, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.errors.create = action.payload as string;
                                          })
                              
                                          // Update 
                                          .addCase(UpdateGoal .pending, (state) => {
                                              state.loadingStates.update = true;
                                              state.errors.update = undefined;
                                          })
                                          .addCase(UpdateGoal .fulfilled, (state, action) => {
                                              state.loadingStates.update = false;
                                              const index = state.goal.findIndex((d : any) => d.Id === action.payload.Id);
                                              if (index !== -1) {
                                                  state.goal[index] = action.payload;
                                              }
                                          })
                                          .addCase(UpdateGoal .rejected, (state, action) => {
                                              state.loadingStates.update = false;
                                              state.errors.update = action.payload as string;
                                          })
                              
                                          // Delete 
                                          .addCase(deleteGoal.pending, (state) => {
                                              state.loadingStates.delete = true;
                                              state.errors.delete = undefined;
                                          })
                                          .addCase(deleteGoal.fulfilled, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.goal = state.goal.filter((d : any) => d.Id !== action.payload);
                                          })
                                          .addCase(deleteGoal.rejected, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.errors.delete = action.payload as string;
                                          })
                              
                                          // Fetch  by ID
                                          .addCase(fetchGoalById.pending, (state) => {
                                              state.loadingStates.fetchById = true;
                                              state.errors.fetchById = undefined;
                                          })
                                          .addCase(fetchGoalById.fulfilled, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.selectedgoal = action.payload;
                                          })
                                          .addCase(fetchGoalById.rejected, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.errors.fetchById = action.payload as string;
                                          })
                              
                                          // Fetch All 
                                          .addCase(fetchAllGoal.pending, (state) => {
                                              state.loadingStates.fetchAll = true;
                                              state.errors.fetchAll = undefined;
                                          })
                                          .addCase(fetchAllGoal.fulfilled, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.goal = action.payload.data;
                                          })
                                          .addCase(fetchAllGoal.rejected, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.errors.fetchAll = action.payload as string;
                                          }); 
    }
})


export default goalSlice.reducer;